import {
  // Select,
  FormControl,
  FormLabel,
  FormHelperText,
} from "@chakra-ui/react";

import Select from "react-select";

export default function SelectComponent({
  label,
  onChange,
  options,
  value,
  multiple = false,
  required = true,
}) {
  const optionList = options?.map((el) => {
    return {
      value: el?.toLowerCase().includes("select") ? "" : el,
      label: el,
    };
  });

  return (
    <>
      <FormControl isRequired={required}>
        <FormLabel fontWeight="medium" color="#515050">
          {label}
        </FormLabel>
        <Select
          styles={{ textTransform: "capitalize" }}
          options={optionList}
          isSearchable={true}
          isMulti={multiple}
          value={value}
          onChange={onChange}
        />
      </FormControl>
    </>
  );
}
